var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTemplate',{attrs:{"currentUser":_vm.currentUser}},[_c('div',{staticClass:"contact-list"},[_c('Title',{attrs:{"jpn":_vm.t('Contact us')}}),_vm._v(" "+_vm._s(_vm.dispContactList)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }